var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogBgBlobLeft = function SvgBlogBgBlobLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 876,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF0FC",
    d: "M205 399C-17.5 479 27.158 876-77.5 876S-267 679.901-267 438-182.158 0-77.5 0s505 319 282.5 399"
  })));
};
export { SvgBlogBgBlobLeft as ReactComponent };
export default "/_next/static/media/src/components/Blog/assets/blogBgBlobLeft.279307bf544a4d8c7a07c87b7ce15cbd.svg";